import { type FragmentType, graphql, useFragment } from "@repo/graphql-types";
import { formatCurrencyFromCentsToReais, formatWithZonedDate } from "@repo/lib";
import { InfoSectionV2 } from "@/components/info-section-v2";

export const PatientPaymentsRefundDetailsSectionFragment = graphql(`
  fragment PatientPaymentsRefundDetailsSectionFragment on ExpensumGetRefundReceiptOutput {
    receipt {
      transactionId
      authorizationId
      paidAt
      paidAmount
      canceledAt
      canceledAmount
    }
  }
`);

interface PatientPaymentsRefundDetailsSectionProps {
  data: FragmentType<typeof PatientPaymentsRefundDetailsSectionFragment>;
}

export const PatientPaymentsRefundDetailsSection = ({
  data,
}: PatientPaymentsRefundDetailsSectionProps): JSX.Element => {
  const refundData = useFragment(PatientPaymentsRefundDetailsSectionFragment, data);
  const refundDetails = refundData.receipt;

  const recipientSection = {
    title: "Detalhes do estorno",
    fields: [
      { label: "ID transação", value: refundDetails?.transactionId },
      { label: "Código de autorização", value: refundDetails?.authorizationId },
      {
        label: "Data do pagamento",
        value: refundDetails?.paidAt
          ? formatWithZonedDate(refundDetails.paidAt, "dd/MM/yyyy")
          : "",
      },
      {
        label: "Valor do pagamento",
        value: formatCurrencyFromCentsToReais(refundDetails?.paidAmount ?? 0),
      },
      {
        label: "Data do estorno",
        value: refundDetails?.canceledAt
          ? formatWithZonedDate(refundDetails.canceledAt ?? "", "dd/MM/yyyy")
          : "",
      },
      {
        label: "Valor do estorno",
        value: formatCurrencyFromCentsToReais(refundDetails?.canceledAmount ?? 0),
      },
    ],
  };

  return <InfoSectionV2 section={recipientSection} />;
};
